module.exports = __webpack_public_path__ + "img/DIANBIAO.26ef55e9.jpg";